
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Hotel } from "lucide-react";

interface HotelImageUploadProps {
  imagePreview: string | null;
  imageUrl?: string;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isUploading: boolean;
  imageUrlValue: string;
}

export const HotelImageUpload = ({ imagePreview, imageUrl, onFileChange, onUrlChange, isUploading, imageUrlValue }: HotelImageUploadProps) => {
  const displayUrl = imagePreview || imageUrlValue || imageUrl;

  return (
    <div className="space-y-2">
      <Label>صورة الفندق</Label>
      <div className="flex items-center gap-4">
        {displayUrl ? (
          <img src={displayUrl} alt="Hotel Preview" className="w-24 h-24 rounded-md object-cover border bg-white" />
        ) : (
          <div className="w-24 h-24 rounded-md bg-gray-100 flex items-center justify-center text-xs text-gray-500 text-center p-1 flex-shrink-0">
             <Hotel className="w-10 h-10 text-gray-400" />
          </div>
        )}
        <div className="flex-1 space-y-2">
            <div>
                <Label htmlFor="image-upload" className="text-xs font-normal">رفع صورة</Label>
                <Input
                    id="image-upload"
                    type="file"
                    onChange={onFileChange}
                    disabled={isUploading}
                    className="text-xs h-9"
                    accept="image/*"
                />
            </div>
            {isUploading && <div className="flex items-center gap-2 text-xs text-blue-600 mt-1"><Loader2 className="w-3 h-3 animate-spin" /> <span>جاري الرفع...</span></div>}
            <div className="flex items-center">
                <div className="flex-grow border-t border-gray-200"></div>
                <span className="flex-shrink mx-2 text-gray-400 text-xs">أو</span>
                <div className="flex-grow border-t border-gray-200"></div>
            </div>
            <div>
                  <Label htmlFor="image-url" className="text-xs font-normal">إضافة رابط صورة</Label>
                <Input
                    id="image-url"
                    type="text"
                    placeholder="https://example.com/image.png"
                    value={imageUrlValue}
                    onChange={onUrlChange}
                    disabled={isUploading}
                    className="text-xs h-9"
                />
            </div>
        </div>
      </div>
    </div>
  );
};
